import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CodeDialogComponent } from '@app/parent-home/code-dialog/code-dialog.component';
import { Icon } from '@wam/components';
import { UpstartAccountType } from '../enrollment-wizard-dialog.service';
import { SnowplowService } from '@app/shared/snowplow/snowplow.service';

@Component({
  selector: 'enrollment-type-dialog',
  templateUrl: './enrollment-type-dialog.component.html',
  styleUrls: ['./enrollment-type-dialog.component.scss'],
  standalone: false,
})
export class EnrollmentTypeDialogComponent implements OnInit, OnDestroy {
  protected readonly Icon = Icon;
  protected readonly UpstartAccountType = UpstartAccountType;
  selectedUpstartAccountType: UpstartAccountType;

  constructor(
    public dialogRef: MatDialogRef<CodeDialogComponent>,
    private snowplowService: SnowplowService,
  ) {}

  ngOnInit() {
    this.snowplowService.enableButtonClickTrackingForEnrollmentFunnel();
  }

  selectUpstartAccountType(upstartAccountType: UpstartAccountType) {
    this.selectedUpstartAccountType = upstartAccountType;
  }

  setUpstartAccountType() {
    this.dialogRef.close(this.selectedUpstartAccountType);
  }

  isSelected(upstartAccountType: UpstartAccountType) {
    return this.selectedUpstartAccountType === upstartAccountType;
  }

  ngOnDestroy() {
    this.snowplowService.disableButtonClickTracking();
  }
}
